import { getSubscribedProducts } from '../../me/products/api';
import { VodPlaybackOption, Media, PlayablePlaybackOption } from '../../titles/types/playback-option';
import { MissingMediaError } from '../error';

export async function getMediaForProduct(option: VodPlaybackOption) {
  const media = option.media.filter((x) => x.type === 'media');
  const entitlements = [...(await getSubscribedProducts()).values()];

  const highestResolutionProduct = entitlements.reduce((p, x) => {
    if (x.platformTitleId !== option.platformTitleId) {
      return p;
    }

    if (p.resolution === 'HD' && p.platformTitleId === option.platformTitleId) {
      return p;
    }

    return x;
  });

  if (highestResolutionProduct === undefined) {
    throw new Error('No product found');
  }

  const mediaForProduct = media.find((x) => x.resolution === highestResolutionProduct.resolution);

  if (mediaForProduct === undefined) {
    throw new MissingMediaError('media');
  }

  return mediaForProduct;
}

export function getMedia(option: PlayablePlaybackOption, type: 'media' | 'clip' = 'media') {
  const media = option.media.filter((x) => x.type === type);

  if (media.length === 0) {
    throw new MissingMediaError(type);
  }

  const bestMedia = getBestResolutionMedia(media);

  if (bestMedia === undefined) {
    throw new MissingMediaError(type);
  }

  return bestMedia;
}

export function getMediaId(option: PlayablePlaybackOption, type: 'media' | 'clip' = 'media') {
  return getMedia(option, type).id;
}

export function getBestResolutionMedia(media: Media[]) {
  return media.reduce((best, m) => {
    if (m.resolution === 'HD') {
      return m;
    }

    if (m.resolution === 'SD') {
      return m;
    }

    return best;
  });
}
